const $ = require('lc-jquery');

module.exports = (function initializer() {
  $(document).ready(function register() {
    window.lcTracking.registerContainerForTracking('body');
  });
})();

